<script setup lang="ts">
defineProps<{
  lightTheme?: boolean
}>()
</script>

<template>
  <section
    class="gap-6 lg:gap-10 px-6 py-8 lg:py-14 mx-auto text-v2-secondary text-sm leading-normal font-medium"
    :class="{
      'light-theme': lightTheme,
      'mb-4 max-w-md lg:max-w-[1040px]': !lightTheme,
      'grid md:grid-cols-2': true,
    }"
  >
    <div id="help-section" class="space-y-4">
      <div>
        <h2 class="text-navy font-semibold mb-4 text-2xl">Help</h2>
        <p class="mb-4">
          If you have questions, need help, or want to modify, resend, or cancel a gift, please see our
          <a href="/support" class="font-semibold hover:underline text-v2-active">Support Center</a>,
          where you can access an array of self-service tools and our FAQ.
        </p>
        <p>
          For other questions or issues, please contact
          <a href="mailto:support@giftly.com" class="font-semibold hover:underline text-v2-active">
            support@giftly.com
          </a>.
        </p>
      </div>
    </div>
    <div id="disclosure-section">
      <h2 class="text-navy font-semibold mb-4 text-2xl">Gift Disclosure</h2>
      <p>
        The Giftly Prepaid Gift is redeemed for money through the Giftly website.
        It is not issued, endorsed, or accepted by any third-party merchant (including any third-party merchant
        explicitly referenced in this Giftly Prepaid Gift), and is not covered by the CARD Act.
        Giftly Prepaid Gifts never expire and there are no inactivity fees.
        Please see the
        <a href="/giftagreement" class="font-semibold hover:underline text-v2-active">Giftly Prepaid Gift Agreement</a>
        for the complete terms.
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.light-theme {
  .text-navy {
    @apply text-v2-tertiary;
  }

  a {
    color: inherit;
    font: inherit;
    text-decoration: underline;

    &:hover {
      @apply text-navy;
    }
  }
}
</style>
